
import { configureStore } from '@reduxjs/toolkit';
import schoolReducer from '../features/school/schoolSlice';
import authReducer from '../features/auth/authSlice';

export const store = configureStore({
  reducer: {
    school: schoolReducer,
    auth: authReducer, 
  },
});
